module.exports = __webpack_public_path__ + "static/bsas016.thumb-6014da11d58974b1326b60ceb8747eb4.jpg";